import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Form, Button, Card, Row, Col } from "react-bootstrap";
import axios from "axios";
import { API_URL_LOCAL } from "..";
import { Icon } from "@iconify/react/dist/iconify.js";

const AddWorkSchedulePage = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    workingDays: {
      Mon: false,
      Tue: false,
      Wed: false,
      Thu: false,
      Fri: false,
      Sat: false,
      Sun: false,
    },
    startTime: "",
    endTime: "",
    lateIn: "",
    earlyOut: "",
    overtime: "",
    numBreaks: 0,
    breakMinutes: [],
    implementation: "location",
    locations: [],
    departments: [],
    individuals: [],
  });
  const [locations, setLocations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [individuals, setIndividuals] = useState([]);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  // Fetch data for dropdowns
  const fetchData = async (passed) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.id) throw new Error("User not found in localStorage");

      // Fetch locations
      if(passed === 'location'){
        const locResponse = await axios.get(`${API_URL_LOCAL}/api/company/fetch/${user.id}`);
        setLocations(locResponse.data.companies || []);
      }else if(passed === 'department'){
        const depResponse = await axios.get(`${API_URL_LOCAL}/api/departments/fetch/${user.id}`);
        setDepartments(depResponse.data.departments || []);
      }else{
        const indResponse = await axios.get(`${API_URL_LOCAL}/api/employees/fetch/${user.id}`);
        setIndividuals(indResponse.data.employees || []); // Assuming { employees: [{ id, name }, ...] }

      }

      // Fetch departments

      // Fetch individuals (mock API; replace with actual endpoint)
    } catch (err) {
      setAlert({ show: true, type: "error", message: err.message });
    }
  };
 useEffect(()=>{

  fetchData('location')
 },[1])

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (day) => {
    setFormData({
      ...formData,
      workingDays: { ...formData.workingDays, [day]: !formData.workingDays[day] },
    });
  };

  const handleBreakChange = (index, value) => {
    const updatedBreaks = [...formData.breakMinutes];
    updatedBreaks[index] = value;
    setFormData({ ...formData, breakMinutes: updatedBreaks });
  };

  const handleNumBreaksChange = (num) => {
    const numBreaks = parseInt(num, 10);
    const breakMinutes = Array(numBreaks).fill("");
    setFormData({ ...formData, numBreaks, breakMinutes });
  };

  const handleImplementationChange = (value) => {
    fetchData(value);
    setFormData({ ...formData, implementation: value, locations: [], departments: [], individuals: [] });
    
  };

  const handleSelectionChange = (type, id) => {
    const currentList = formData[type];
    const updatedList = currentList.includes(id)
      ? currentList.filter((item) => item !== id)
      : [...currentList, id];
    setFormData({ ...formData, [type]: updatedList });
  };

  // Validation
  const validateStep = () => {
    if (step === 1) {
      const selectedDays = Object.values(formData.workingDays).some((day) => day);
      if (!formData.name || !selectedDays || !formData.startTime || !formData.endTime) {
        setAlert({ show: true, type: "error", message: "Please fill all fields in Step 1" });
        return false;
      }
    } else if (step === 2) {
      if (!formData.lateIn || !formData.earlyOut || !formData.overtime) {
        setAlert({ show: true, type: "error", message: "Please fill all fields in Step 2" });
        return false;
      }
    } else if (step === 3) {
      if (formData.numBreaks > 0 && formData.breakMinutes.some((min) => !min)) {
        setAlert({ show: true, type: "error", message: "Please fill all break minutes" });
        return false;
      }
    } else if (step === 4) {
      const selected =
        (formData.implementation === "location" && formData.locations.length > 0) ||
        (formData.implementation === "department" && formData.departments.length > 0) ||
        (formData.implementation === "individual" && formData.individuals.length > 0);
      if (!selected) {
        setAlert({ show: true, type: "error", message: "Please select at least one implementation option" });
        return false;
      }
    }
    setAlert({ show: false, type: "", message: "" });
    return true;
  };

  // Handle navigation
  const nextStep = () => {
    if (validateStep()) setStep(step + 1);
  };
  const prevStep = () => setStep(step - 1);

  // Handle form submission
  const handleSubmit = async () => {
    if (!validateStep()) return;

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      
      const payload = {
        schedule_name:formData.name,
        work_days: Object.keys(formData.workingDays)
        .filter((day) => formData.workingDays[day])
        .join(","),
        start_time: formData.startTime,
        end_time:  formData.endTime,
        no_of_breaks: formData.numBreaks,
        breaks_mints: formData.breakMinutes.join(","),
        trady_margin: parseInt(formData.lateIn, 10),
        early_out_margin: parseInt(formData.earlyOut, 10),
        overtime_margin: parseInt(formData.overtime, 10),
        org_id: user.id,
        type: formData.implementation,
        selected_Ids:formData.implementation === "location" ? formData.locations.toString()  : formData.implementation === 'department' ? formData.departments.toString() : formData.implementation === 'individual' ? formData.individuals.toString(): '',
      };
      const response = await axios.post(`${API_URL_LOCAL}/api/work-schedule/create`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 201) {
        setAlert({ show: true, type: "success", message: "Work schedule added successfully!" });
        setFormData({
          name: "",
          workingDays: { Mon: false, Tue: false, Wed: false, Thu: false, Fri: false, Sat: false, Sun: false },
          startTime: "",
          endTime: "",
          lateIn: "",
          earlyOut: "",
          overtime: "",
          numBreaks: 0,
          breakMinutes: [],
          implementation: "location",
          locations: [],
          departments: [],
          individuals: [],
        });
        setStep(1);
      }
    } catch (err) {
      setAlert({ show: true, type: "error", message: "Failed to add work schedule: " + err.message });
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Add Work Schedule" />
      <div className="card">
      <div className="row justify-content-center ">
                <div className="col-xxl-8 col-xl-8 col-lg-10">
            <Card className=" p-24">
            <Card.Body>
              <h6 className="mb-20">Step {step} of 4</h6>
              <Form>
                {step === 1 && (
                  <>
                    <Form.Group className="mb-20">
                      <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                        Schedule Name <span className="text-danger-600">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter Schedule Name"
                        className="radius-8"
                      />
                    </Form.Group>
                    <Form.Group className="mb-20">
                      <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                        Select Working Days <span className="text-danger-600">*</span>
                      </Form.Label>
                      <Row>
                        {Object.keys(formData.workingDays).map((day) => (
                          <Col xs={6} md={3} key={day} className="mb-2">
                            <Form.Check
                              type="checkbox"
                              label={day}
                              checked={formData.workingDays[day]}
                              onChange={() => handleCheckboxChange(day)}
                              custom
                              className="form-check-inline check-custom"
                            />
                          </Col>
                        ))}
                      </Row>
                    </Form.Group>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-20">
                          <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                            Start Time <span className="text-danger-600">*</span>
                          </Form.Label>
                          <Form.Control
                            type="time"
                            name="startTime"
                            value={formData.startTime}
                            onChange={handleChange}
                            className="radius-8"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-20">
                          <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                            End Time <span className="text-danger-600">*</span>
                          </Form.Label>
                          <Form.Control
                            type="time"
                            name="endTime"
                            value={formData.endTime}
                            onChange={handleChange}
                            className="radius-8"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}

                {step === 2 && (
                  <>
                    <h6 className="mb-20">Schedule Timings</h6>
                    <Form.Group className="mb-20">
                      <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                        Late In (minutes) <span className="text-danger-600">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="lateIn"
                        value={formData.lateIn}
                        onChange={handleChange}
                        placeholder="Enter minutes (e.g., 5)"
                        min="1"
                        max="5"
                        className="radius-8"
                      />
                    </Form.Group>
                    <Form.Group className="mb-20">
                      <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                        Early Out (minutes) <span className="text-danger-600">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="earlyOut"
                        value={formData.earlyOut}
                        onChange={handleChange}
                        placeholder="Enter minutes (e.g., 5)"
                        min="1"
                        max="5"
                        className="radius-8"
                      />
                    </Form.Group>
                    <Form.Group className="mb-20">
                      <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                        Overtime (minutes) <span className="text-danger-600">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="overtime"
                        value={formData.overtime}
                        onChange={handleChange}
                        placeholder="Enter minutes (e.g., 5)"
                        min="1"
                        max="5"
                        className="radius-8"
                      />
                    </Form.Group>
                  </>
                )}

                {step === 3 && (
                  <>
                    <Form.Group className="mb-20">
                      <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                        Number of Breaks
                      </Form.Label>
                      <Row>
                        {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                          <Col xs={6} md={3} key={num} className="mb-2">
                            <Form.Check
                              type="checkbox"
                              label={num}
                              checked={formData.numBreaks === num}
                              onChange={() => handleNumBreaksChange(num)}
                              custom
                              className="form-check-inline check-custom"
                            />
                          </Col>
                        ))}
                      </Row>
                    </Form.Group>
                    {formData.numBreaks > 0 && (
                      <div>
                        <h6 className="mb-20">Break Durations (minutes)</h6>
                        {Array.from({ length: formData.numBreaks }).map((_, index) => (
                          <Form.Group key={index} className="mb-20">
                            <Form.Label className="fw-semibold text-primary-light text-sm mb-8">
                              Break {index + 1} (minutes) <span className="text-danger-600">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              value={formData.breakMinutes[index] || ""}
                              onChange={(e) => handleBreakChange(index, e.target.value)}
                              placeholder="Enter minutes"
                              className="radius-8"
                              min="1"
                            />
                          </Form.Group>
                        ))}
                      </div>
                    )}
                  </>
                )}

                {step === 4 && (
                  <>
                    <h6 className="mb-20">Implementation</h6>
                    <Form.Group className="mb-20">
                      <Form.Check
                        type="radio"
                        label="Location"
                        name="implementation"
                        value="location"
                        checked={formData.implementation === "location"}
                        onChange={() => handleImplementationChange("location")}
                        className="mb-2 check-custom"
                      />
                      {formData.implementation === "location" && (
                        <div className="ms-4">
                          {locations.map((loc) => (
                            <Form.Check
                              key={loc.id}
                              type="checkbox"
                              label={loc.title}
                              checked={formData.locations.includes(loc.id)}
                              onChange={() => handleSelectionChange("locations", loc.id)}
                              className="mb-2 check-custom"
                            />
                          ))}
                        </div>
                      )}
                      <Form.Check
                        type="radio"
                        label="Department"
                        name="implementation"
                        value="department"
                        checked={formData.implementation === "department"}
                        onChange={() => handleImplementationChange("department")}
                        className="mb-2 check-custom"
                      />
                      {formData.implementation === "department" && (
                        <div className="ms-4">
                          {departments.map((dep) => (
                            <Form.Check
                              key={dep.id}
                              type="checkbox"
                              label={dep.name}
                              checked={formData.departments.includes(dep.id)}
                              onChange={() => handleSelectionChange("departments", dep.id)}
                              className="mb-2 check-custom"
                            />
                          ))}
                        </div>
                      )}
                      <Form.Check
                        type="radio"
                        label="Individual"
                        name="implementation"
                        value="individual"
                        checked={formData.implementation === "individual"}
                        onChange={() => handleImplementationChange("individual")}
                        className="mb-2 check-custom"
                      />
                      {formData.implementation === "individual" && (
                        <div className="ms-4">
                          {individuals.map((ind) => (
                            <Form.Check
                              key={ind.id}
                              type="checkbox"
                              label={ind.name} // Assuming employees have a "name" field
                              checked={formData.individuals.includes(ind.id)}
                              onChange={() => handleSelectionChange("individuals", ind.id)}
                              className="mb-2 check-custom"
                            />
                          ))}
                        </div>
                      )}
                    </Form.Group>
                  </>
                )}

                <div className="d-flex justify-content-between mt-4">
                  {step > 1 && (
                    <Button
                      variant="outline-primary"
                      className="text-md px-24 py-8 radius-8"
                      onClick={prevStep}
                    >
                      Previous
                    </Button>
                  )}
                  {step < 4 && (
                    <Button
                      variant="primary"
                      className="text-md px-24 py-8 radius-8 ms-auto"
                      onClick={nextStep}
                    >
                      Next
                    </Button>
                  )}
                  {step === 4 && (
                    <Button
                      variant="primary"
                      className="text-md px-24 py-8 radius-8 ms-auto"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  )}
                </div>
                {alert.show && (
                  <div
                    className={`alert alert-${alert.type} bg-${alert.type}-50 text-${alert.type}-600 border-${alert.type}-50 px-24 py-11 mt-20 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between`}
                  >
                    {alert.message}
                    <button
                      type="button"
                      onClick={() => setAlert({ show: false, type: "", message: "" })}
                      className="text-secondary-600 text-xxl"
                    >
                      <Icon icon="iconamoon:sign-times-light" />
                    </button>
                  </div>
                )}
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
      </div>
    </MasterLayout>
  );
};

export default AddWorkSchedulePage;